import { useState, useEffect } from 'react';

// These initial default values below are needed because the useEffect below first runs on the server where `window` is not defined.
// These values will be immediately adjusted on the front-end.
const INITIAL_HEIGHT = 715;
const INITIAL_WIDTH = 1440;
const MOBILE_WIDTH = 768;

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState({
    height: INITIAL_HEIGHT,
    width: INITIAL_WIDTH,
  });

  function handleResize() {
    setWindowDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      handleResize();
      window.addEventListener('resize', handleResize);
    }

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    ...windowDimensions,
    isMobile: windowDimensions.width <= MOBILE_WIDTH,
    isDesktop: windowDimensions.width > MOBILE_WIDTH,
  };
}
